import { useState } from 'react'
import FormComponent from '../Form/Form'
import { TextInputComponent, ButtonComponent } from '../../uicomponents'
import { ClientTypes } from '../../utilities/constants'
import { useDispatch } from 'react-redux'
import { showMessage, deleteMessage } from '../../redux/states/emailSlice'
import { showError, resetError } from '../../redux/states/errorSlice'
import { sendEmailWaitlistPlaces } from '../../services/email.service'
import { Formik } from 'formik'
import { PlacesFormSchema } from '../../utilities/validationSchema'
import styles from './FormPlacesWaitlist.module.scss'

const FormPlacesWaitlistComponent = () => {
    const dispatch = useDispatch()
    const [loading, setLoading] = useState<boolean>(false)

    const clearFields = (fields:any) => {
        fields.name = ''
        fields.email = ''
        fields.place = ''
        fields.phone = ''
    }

    return (
        <Formik
            initialValues={{
                email: '',
                name: '',
                place: '',
                phone: ''
            }}
            validationSchema={PlacesFormSchema}
            onSubmit={async (valores) => {
                setLoading(true)
                try {
                    const result = await sendEmailWaitlistPlaces({
                        email: valores.email,
                        name: valores.name,
                        place: valores.place,
                        phone: valores.phone
                    })

                    // if (result?.code !== 200) {
                    //     clearFields(valores)
                    //     return
                    // }

                    console.log(result.data)
                    setLoading(false)
                    dispatch(showMessage({ show: true }))
                    clearFields(valores)
                    setTimeout(() => {
                        dispatch(deleteMessage())
                    }, 4000)
                } catch (e) {
                    setLoading(false)
                    dispatch(showError({ show: true }))
                    setTimeout(() => {
                        dispatch(resetError())
                    }, 4000)
                }
            }}
        >
            {({ handleSubmit, values, handleChange, handleBlur, errors }) => (
                <FormComponent
                    onSubmit={handleSubmit}
                >
                    <div className={styles.formWrapper}>
                        <TextInputComponent
                            type={'text'}
                            id={'name'}
                            name={'name'}
                            placeholder='Tu nombre*'
                            value={values.name}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            onError={errors.name && true}
                            />
                        <TextInputComponent
                            type={'text'}
                            id={'place'}
                            name={'place'}
                            placeholder='Tu lugar*'
                            value={values.place}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            onError={errors.place && true}
                        />
                        <TextInputComponent
                            type={'email'}
                            id={'email'}
                            name={'email'}
                            placeholder='Tu mail*'
                            value={values.email}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            onError={errors.email && true}
                        />
                        <TextInputComponent
                            type={'text'}
                            id={'phone'}
                            name={'phone'}
                            placeholder='Tu teléfono'
                            value={values.phone}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            onError={errors.phone && true}
                        />
                        <ButtonComponent
                            client={ClientTypes.PLACES}
                            loading={loading}
                        >
                            {loading ? '¡Uniendose!' : '¡Unirme ahora!'}
                        </ButtonComponent>
                    </div>
                </FormComponent>
            )}
        </Formik>
    )
}

export default FormPlacesWaitlistComponent
